
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("K0HEo", function(module, exports) {
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $6a2ece5716de6726$export$951bf5156e86d974 = '--n_sNvw';
const $6a2ece5716de6726$export$594e6a30db7c057e = '--n_asDw';
const $6a2ece5716de6726$export$db0c2e1d744fb281 = '--n_pnlW';
const $6a2ece5716de6726$export$515a0b1baafe906c = '--n_bnrM';
const $6a2ece5716de6726$export$60ef3a7b1ed42328 = '--n_tNvM';
const $6a2ece5716de6726$export$a16bbd599f6269e7 = '--n_rbnW';
const $6a2ece5716de6726$export$1216dacffd1e9e65 = '--n_sNvlw';
const $6a2ece5716de6726$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $6a2ece5716de6726$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $6a2ece5716de6726$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $6a2ece5716de6726$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $6a2ece5716de6726$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $6a2ece5716de6726$export$855f5a09f5c99ac = '--topNavigationHeight';
const $6a2ece5716de6726$export$26354f9814213292 = '--bannerHeight';
const $6a2ece5716de6726$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $6a2ece5716de6726$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $6a2ece5716de6726$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $6a2ece5716de6726$export$753bf7651b25db91 = '--rightPanelWidth';
const $6a2ece5716de6726$export$6460bd6a2446260 = `calc(var(${$6a2ece5716de6726$export$26354f9814213292}, 0px) + var(${$6a2ece5716de6726$export$855f5a09f5c99ac}, 0px))`;
const $6a2ece5716de6726$export$3055529fab2b4edf = `calc(var(${$6a2ece5716de6726$export$58de0a46980ca7f4}, 0px) + var(${$6a2ece5716de6726$export$6bfc931a04ec5741}, 0px))`;
const $6a2ece5716de6726$export$166d8fd766c3eb92 = `calc(var(${$6a2ece5716de6726$export$bbbace2ff0c7ae1b}, 0px) + var(${$6a2ece5716de6726$export$753bf7651b25db91}, 0px))`;
const $6a2ece5716de6726$export$61156ceb1a99f6a0 = {
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
const $6a2ece5716de6726$export$876effa8b02edc2f = 'side-nav';
const $6a2ece5716de6726$export$a6be839a92c90df7 = 'top-nav-start';
const $6a2ece5716de6726$export$762ad20d97870b35 = 'top-nav-middle';
const $6a2ece5716de6726$export$8dd71e8a7db48024 = 'top-nav-end';
const $6a2ece5716de6726$export$bb9dc5de75de3bf = '--sNcst';
module.exports["sideNavVar"] = $6a2ece5716de6726$export$951bf5156e86d974;
module.exports["panelVar"] = $6a2ece5716de6726$export$db0c2e1d744fb281;
module.exports["bannerMountedVar"] = $6a2ece5716de6726$export$515a0b1baafe906c;
module.exports["topNavMountedVar"] = $6a2ece5716de6726$export$60ef3a7b1ed42328;
module.exports["sideNavLiveWidthVar"] = $6a2ece5716de6726$export$1216dacffd1e9e65;
module.exports["sideNavPanelSplitterId"] = $6a2ece5716de6726$export$5db28b16b6e686bc;
module.exports["panelPanelSplitterId"] = $6a2ece5716de6726$export$3452dcb65711af44;
module.exports["contentInsetBlockStart"] = $6a2ece5716de6726$export$bfabd8c2c572ad29;
module.exports["UNSAFE_topNavVar"] = $6a2ece5716de6726$export$855f5a09f5c99ac;
module.exports["UNSAFE_bannerVar"] = $6a2ece5716de6726$export$26354f9814213292;
module.exports["UNSAFE_sideNavLayoutVar"] = $6a2ece5716de6726$export$6bfc931a04ec5741;
module.exports["UNSAFE_panelLayoutVar"] = $6a2ece5716de6726$export$753bf7651b25db91;
module.exports["UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY"] = $6a2ece5716de6726$export$6460bd6a2446260;
module.exports["openLayerObserverSideNavNamespace"] = $6a2ece5716de6726$export$876effa8b02edc2f;
module.exports["openLayerObserverTopNavStartNamespace"] = $6a2ece5716de6726$export$a6be839a92c90df7;
module.exports["openLayerObserverTopNavMiddleNamespace"] = $6a2ece5716de6726$export$762ad20d97870b35;
module.exports["openLayerObserverTopNavEndNamespace"] = $6a2ece5716de6726$export$8dd71e8a7db48024;

});

parcelRegister("fQcKS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $cGkQr = parcelRequire("cGkQr");


var $4pUFZ = parcelRequire("4pUFZ");

function $b83059ddc27aa2a1$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $4pUFZ.useOpenLayerObserverNamespace)();
    (0, $42omo.useEffect)(()=>{
        (0, $dRnqM.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGkQr.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}
module.exports["OpenLayerObserverNamespaceProvider"] = $b83059ddc27aa2a1$export$327d0d2a7ae6f7cc;

});

parcelRegister("dEIJ1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $120f326e2f61fdb7$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $42omo.createContext)({
    registerSkipLink: (0, $ee7An.default),
    unregisterSkipLink: (0, $ee7An.default)
});
const $120f326e2f61fdb7$var$useSkipLinks = ()=>(0, $42omo.useContext)($120f326e2f61fdb7$export$4c5cc3b14c7678a);
const $120f326e2f61fdb7$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $120f326e2f61fdb7$var$useSkipLinks();
    (0, $42omo.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $120f326e2f61fdb7$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    $120f326e2f61fdb7$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};
module.exports["SkipLinksContext"] = $120f326e2f61fdb7$export$4c5cc3b14c7678a;
module.exports["useSkipLinkInternal"] = $120f326e2f61fdb7$export$707b94c26b8b75aa;
module.exports["useSkipLink"] = $120f326e2f61fdb7$export$89d9323301efc7d6;

});

parcelRegister("7plVH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $0ba4ee02bbd088fc$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $0ba4ee02bbd088fc$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["TopNavStartElement"] = $0ba4ee02bbd088fc$export$e9e5087bd319cc8c;
module.exports["TopNavStartAttachRef"] = $0ba4ee02bbd088fc$export$55f0a642b785fb1f;

});

parcelRegister("8jREP", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f3ec473aa51c642a$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $42omo.createContext)(false);
module.exports["DangerouslyHoistSlotSizes"] = $f3ec473aa51c642a$export$66e2c1a0115af861;

});

parcelRegister("dGAIk", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $82dFP = parcelRequire("82dFP");

const $f173fcb581d867c3$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $l998X.jsx)("style", {
        children: `#${(0, $82dFP.gridRootId)} { ${variableName}: ${value}px }`
    });
const $f173fcb581d867c3$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $f173fcb581d867c3$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$f173fcb581d867c3$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$f173fcb581d867c3$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $l998X.jsx)("style", {
        children: style
    }));
};
module.exports["HoistCssVarToLocalGrid"] = $f173fcb581d867c3$export$cfa3cd08d675e56e;
module.exports["DangerouslyHoistCssVarToDocumentRoot"] = $f173fcb581d867c3$export$9f45a1325e3cdfb8;

});

parcelRegister("82dFP", function(module, exports) {
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $4jakm = parcelRequire("4jakm");


var $dh538 = parcelRequire("dh538");


var $eXTHI = parcelRequire("eXTHI");


var $i5D3A = parcelRequire("i5D3A");


var $8zs3p = parcelRequire("8zs3p");


var $8jREP = parcelRequire("8jREP");


var $dh62b = parcelRequire("dh62b");


var $9OYu5 = parcelRequire("9OYu5");


var $94Rup = parcelRequire("94Rup");


var $1Uf7b = parcelRequire("1Uf7b");

const $7d16529c767c75c3$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $7d16529c767c75c3$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8",
    sideNavScrollTimeline: "_10iwgc9s",
    ribbon: "_12fk1aio _12qzrxre _1rqteala _xkmgks3h _jbc7rxre _tyve1nco"
}; /**
    * The root component of the navigation system. It wraps the underlying components with the necessary contexts allowing to use certain data and hooks
    * @param skipLinksLabel - The very first element of the layout is a skip links container that can be accessed by pressing Tab button and holds the links to the other sections of the layout thus improving accessibility. This parameter defines the header text for this container
    */ 
function $7d16529c767c75c3$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId, defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: isSideNavShortcutEnabled = false }) {
    const ref = (0, $42omo.useRef)(null);
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    (0, $42omo.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Uf7b.SideNavVisibilityProvider), {
        defaultCollapsed: defaultSideNavCollapsed,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $94Rup.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dh62b.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9OYu5.IsSideNavShortcutEnabledProvider), {
                    isSideNavShortcutEnabled: isSideNavShortcutEnabled,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i5D3A.TopNavStartProvider), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4jakm.OpenLayerObserver), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8jREP.DangerouslyHoistSlotSizes).Provider, {
                                value: UNSAFE_dangerouslyHoistSlotSizes,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eXTHI.SkipLinksProvider), {
                                    label: skipLinksLabel,
                                    testId: testId,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                        ref: ref,
                                        className: (0, $gMc0m.default)([
                                            $7d16529c767c75c3$var$styles.root,
                                            isFhsEnabled && !(0, $dh538.fg)('platform_dst_nav4_fhs_feedback_1') && $7d16529c767c75c3$var$styles.sideNavScrollTimeline,
                                            (0, $dh538.fg)('platform_dst_nav4_ribbon_slot') && $7d16529c767c75c3$var$styles.ribbon,
                                            xcss
                                        ]),
                                        id: $7d16529c767c75c3$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
module.exports["gridRootId"] = $7d16529c767c75c3$export$a6d827031bcb31d1;
module.exports["Root"] = $7d16529c767c75c3$export$be92b6f5f03c0fe9;

});

parcelRegister("4jakm", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $iHNqU = parcelRequire("iHNqU");

/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $c174b6783566d938$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $c174b6783566d938$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function $c174b6783566d938$var$getLayerCountWithFilter({ layers: layers, type: type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $c174b6783566d938$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $c174b6783566d938$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The registered layers for each namespace.
	 * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
	 * **When the layer is open**, its `onClose`
	 * callback is registered in this set along with its type.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($c174b6783566d938$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $c174b6783566d938$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * - If a namespace is provided, the count for that namespace is returned.
	 * - If a type is provided, only layers of that type are counted.
	 * - If both are provided, only layers matching both criteria are counted.
	 * - Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace, type: type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return $c174b6783566d938$var$getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + $c174b6783566d938$var$getLayerCountWithFilter({
                layers: layers,
                type: type
            }), 0);
        // No type filter - count all layers across all namespaces
        return $c174b6783566d938$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $c174b6783566d938$var$noNamespaceSymbol;
        const listenersForNamespace = $c174b6783566d938$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace, type: type }) {
        const wrapped = {
            listener: listener,
            type: type
        };
        const namespace = providedNamespace ?? $c174b6783566d938$var$noNamespaceSymbol;
        const listenersForNamespace = $c174b6783566d938$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener: listener })=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $c174b6783566d938$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $42omo.useState)(()=>$c174b6783566d938$var$createInternalAPI());
    const parentContext = (0, $42omo.useContext)((0, $iHNqU.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $dRnqM.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iHNqU.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}
module.exports["OpenLayerObserver"] = $c174b6783566d938$export$97afddda23bcd287;

});

parcelRegister("eXTHI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kRPaB = parcelRequire("kRPaB");


var $dEIJ1 = parcelRequire("dEIJ1");

const $26ba81d5dbd9fe8d$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
function $26ba81d5dbd9fe8d$export$fe514f9f7b03d46f({ children: children, label: label, testId: testId }) {
    const [links, setLinks] = (0, $42omo.useState)([]);
    const registerSkipLink = (0, $42omo.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($26ba81d5dbd9fe8d$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $42omo.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dEIJ1.SkipLinksContext).Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kRPaB.SkipLinksContainer), {
                label: label,
                testId: testId,
                links: links
            }),
            children
        ]
    });
}
module.exports["SkipLinksProvider"] = $26ba81d5dbd9fe8d$export$fe514f9f7b03d46f;

});

parcelRegister("kRPaB", function(module, exports) {
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iXCQx = parcelRequire("iXCQx");


var $480dg = parcelRequire("480dg");

const $aa51ab1d068fecb1$var$styles = {
    root: "_zulp1b66 _2rko12b0 _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs130s _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
}; /**
    * Keydown handler to hide the skip links when escape is pressed.
    *
    * TODO: consider removing this, it doesn't make a lot of sense.
    * The skip links look like a popup but in reality they aren't.
    * Even though we hide them when the user presses Escape, when
    * they press TAB it will reopen the list and move to the next one...
    *
    * One potential option is to use a tree walker to focus on the
    * next focusable element in the DOM (outside the skip links
    * container).
    */ 
const $aa51ab1d068fecb1$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $aa51ab1d068fecb1$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $aa51ab1d068fecb1$var$assignIndex(num + 1, arr);
}; /**
    * Sorts an array of skip links by list indexes.
    *
    * Skip links with custom list indexes are positioned first, followed by regular skip links,
    * which are automatically assigned available index positions to avoid conflicts.
    */ 
function $aa51ab1d068fecb1$var$sortSkipLinks(arr) {
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIndex = arr.filter((link)=>link.listIndex === undefined).map((link, index)=>{
        const listIndex = $aa51ab1d068fecb1$var$assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIndex
    ].sort((a, b)=>a.listIndex - b.listIndex);
}
const $aa51ab1d068fecb1$var$isOnlyWhitespaceRegex = /^\s*$/; /**
                                        * A container element for the skip links.
                                        *
                                        * The container element is always rendered in the DOM, but is only visible when
                                        * focus is within the container.
                                        *
                                        * The label is used as the heading of the skip links container. If the provided label is a string
                                        * comprised only of only whitespace (e.g. '' or ' '), the skip link heading element will be removed.
                                        *
                                        * The links prop is only used when the feature flag is enabled.
                                        */ 
function $aa51ab1d068fecb1$export$fce25a0c32fbc1e1({ label: label, testId: testId, links: links }) {
    const sortedLinks = (0, $42omo.useMemo)(()=>{
        return $aa51ab1d068fecb1$var$sortSkipLinks(links);
    }, [
        links
    ]);
    if (sortedLinks.length === 0) return null;
    const isEmptyLabel = $aa51ab1d068fecb1$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        onKeyDown: $aa51ab1d068fecb1$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $gMc0m.default)([
            $aa51ab1d068fecb1$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("ol", {
                className: (0, $gMc0m.default)([
                    $aa51ab1d068fecb1$var$styles.skipLinkList
                ]),
                children: sortedLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $480dg.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
}
module.exports["SkipLinksContainer"] = $aa51ab1d068fecb1$export$fce25a0c32fbc1e1;

});

parcelRegister("480dg", function(module, exports) {
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $auNCB = parcelRequire("auNCB");

const $c2dcbf5f910c3a70$var$styles = {
    skipLinkListItem: "_1pfhze3t"
}; /**
    * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
    */ 
function $c2dcbf5f910c3a70$var$focusElement(element) {
    /**
  * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
  * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
  *
  * Our slots are not interactive, so this is required.
  *
  * In the future we may want to check if there is an existing `tabindex` attribute,
  * as custom skip linked elements might already have one.
  */ element.setAttribute('tabindex', '-1');
    /**
  * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
  *
  * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
  *
  * - mess with click events
  * - potentially cause a focus ring to be always visible
  */ (0, $fFa3V.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
  * Move focus to the slot or custom target.
  *
  * Calling `.focus()` will also scroll the element into view:
  * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
  */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $c2dcbf5f910c3a70$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault(); // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
         /**
      * Internal slots can attach an `onBeforeNavigate` callback.
      *
      * Side nav uses this to ensure it is expanded.
      */ 
        onBeforeNavigate?.();
        $c2dcbf5f910c3a70$var$focusElement(target);
        /**
    * We should look into removing this, or only calling it in specific cases.
    *
    * It means if the skip link element is in the window scroll container
    * then it might not get scrolled into view properly.
    *
    * This is not an issue for the default slots on desktop, but could break custom skip links or
    * even `Aside` on mobile.
    *
    * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
    * E.g. jumping to main / aside it makes sense to look at the start of the content.
    */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("li", {
        className: (0, $gMc0m.default)([
            $c2dcbf5f910c3a70$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default /**
           * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
           *
           * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
           * in the `onClick` handler.
           */ ), {
            tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};
module.exports["SkipLink"] = $c2dcbf5f910c3a70$export$ef95c37428582a65;

});

parcelRegister("i5D3A", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7plVH = parcelRequire("7plVH");

const $9d4ae14bc558cfed$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $42omo.useState)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7plVH.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7plVH.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
module.exports["TopNavStartProvider"] = $9d4ae14bc558cfed$export$bc9d0ad0bce43e75;

});

parcelRegister("dh62b", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $ea7a9e744546d604$var$SideNavRefContext = /*#__PURE__*/ (0, $42omo.createContext)({
    current: null
});
function $ea7a9e744546d604$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)($ea7a9e744546d604$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $ea7a9e744546d604$export$fa4d0cff03b1ea4f() {
    return (0, $42omo.useContext)($ea7a9e744546d604$var$SideNavRefContext);
}
module.exports["SideNavElementProvider"] = $ea7a9e744546d604$export$85c1ff84bbf6e6dc;
module.exports["useSideNavRef"] = $ea7a9e744546d604$export$fa4d0cff03b1ea4f;

});

parcelRegister("9OYu5", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

/**
 * Context for whether the side nav toggle shortcut is enabled.
 *
 * Used to share the `isSideNavShortcutEnabled` prop value from `Root` with other components,
 * so the visual keyboard shortcut in tooltips can be conditionally displayed.
 */ const $1074d929e518961a$var$IsSideNavShortcutEnabledContext = /*#__PURE__*/ (0, $42omo.createContext)(false);
function $1074d929e518961a$export$f76029d097da8c58({ children: children, isSideNavShortcutEnabled: isSideNavShortcutEnabled }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($1074d929e518961a$var$IsSideNavShortcutEnabledContext.Provider, {
        value: isSideNavShortcutEnabled,
        children: children
    });
}
function $1074d929e518961a$export$be30cdcd17f95ec7() {
    return (0, $42omo.useContext)($1074d929e518961a$var$IsSideNavShortcutEnabledContext);
}
module.exports["IsSideNavShortcutEnabledProvider"] = $1074d929e518961a$export$f76029d097da8c58;
module.exports["useIsSideNavShortcutEnabled"] = $1074d929e518961a$export$be30cdcd17f95ec7;

});

parcelRegister("94Rup", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5fMbj = parcelRequire("5fMbj");

const $b1445687ddf9ea3f$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $42omo.useState)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5fMbj.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5fMbj.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
module.exports["SideNavToggleButtonProvider"] = $b1445687ddf9ea3f$export$ceb8e60e9790fc0f;

});

parcelRegister("5fMbj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $30ef713eae219229$export$9c1768094bef896 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $30ef713eae219229$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["SideNavToggleButtonElement"] = $30ef713eae219229$export$9c1768094bef896;
module.exports["SideNavToggleButtonAttachRef"] = $30ef713eae219229$export$fb8fa9a80240785e;

});

parcelRegister("1Uf7b", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cvtof = parcelRequire("cvtof");

const $4119ec4ede116159$export$aac8e996360f6ad9 = ({ children: children, defaultCollapsed: defaultCollapsed })=>{
    const initialState = typeof defaultCollapsed === 'boolean' ? {
        desktop: defaultCollapsed ? 'collapsed' : 'expanded',
        mobile: 'collapsed',
        flyout: 'closed',
        lastTrigger: null
    } : null;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $42omo.useState)(initialState);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cvtof.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cvtof.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};
module.exports["SideNavVisibilityProvider"] = $4119ec4ede116159$export$aac8e996360f6ad9;

});

parcelRegister("bgZhH", function(module, exports) {

var $c0qxy = parcelRequire("c0qxy");

function $945399976d81ad92$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $c0qxy.useId)();
    return uniqueId;
}
function $945399976d81ad92$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $945399976d81ad92$export$fa3cfac0c8e29c5c();
    const id = providedId ? providedId : uniqueId;
    return id;
}
module.exports["useLayoutId"] = $945399976d81ad92$export$110c3550c7c1c9aa;

});

parcelRegister("huiud", function(module, exports) {
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $3ce0a5d7f35b6a1f$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];
module.exports["sideNavToggleTooltipKeyboardShortcut"] = $3ce0a5d7f35b6a1f$export$bcd616a79072c3e4;

});

parcelRegister("7R2w7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cvtof = parcelRequire("cvtof");

const $f8794fde192899a4$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $42omo.useContext)((0, $cvtof.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};
module.exports["useSideNavVisibility"] = $f8794fde192899a4$export$4a602ad7e09bdb2c;

});


//# sourceMappingURL=assets-object-graph-modal.4cd2ee96.js.map
